import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { MsalService } from "@azure/msal-angular";

/**
 * Auth Guard
 * Protects routes by requiring authentication
 *
 * Usage in routes:
 * {
 *   path: 'dashboard',
 *   component: DashboardComponent,
 *   canActivate: [authGuard]
 * }
 */
export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  const activeAccount = msalService.instance.getActiveAccount();

  if (activeAccount) {
    return true;
  }

  return router.createUrlTree(["/login"]);
};
